import { StyleSheet } from 'react-native';
import { ONBOARDING_COLORS } from '../../src/tutorial/constants/onboardingContent.constants';

export const flexArtStyles = StyleSheet.create({
  scene: {
    width: '100%',
    alignItems: 'center',
    gap: 12,
  },
  mascotStage: {
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ONBOARDING_COLORS.purpleDeep2,
    borderRadius: 24,
    overflow: 'hidden',
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.5,
    shadowRadius: 12,
    elevation: 8,
  },
  gearGrid: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: 8,
  },
  gearCell: {
    width: '48%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    borderRadius: 999,
    borderWidth: 1,
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
  gearCellOn: {
    backgroundColor: ONBOARDING_COLORS.surfaceRaised,
    borderColor: ONBOARDING_COLORS.purple,
  },
  gearCellOff: {
    backgroundColor: ONBOARDING_COLORS.surface,
    borderColor: ONBOARDING_COLORS.border,
  },
  gearCellPressed: {
    transform: [{ scale: 0.96 }],
  },
  gearDot: {
    width: 7,
    height: 7,
    borderRadius: 999,
  },
  gearLabel: {
    fontSize: 12.5,
    fontWeight: '700',
  },
  gearLabelOn: {
    color: ONBOARDING_COLORS.textPrimary,
  },
  gearLabelOff: {
    color: ONBOARDING_COLORS.textSub,
  },
  gearHint: {
    fontSize: 13,
    color: ONBOARDING_COLORS.textSub,
    textAlign: 'center',
  },
  lbCard: {
    width: '100%',
    backgroundColor: ONBOARDING_COLORS.surface,
    borderRadius: 16,
    paddingVertical: 14,
    paddingHorizontal: 14,
    gap: 6,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.4,
    shadowRadius: 10,
    elevation: 6,
  },
  lbHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 2,
  },
  lbHeaderLabel: {
    fontSize: 10.5,
    fontWeight: '700',
    letterSpacing: 1,
    color: ONBOARDING_COLORS.textSub,
  },
  lbClimbing: {
    fontSize: 11,
    fontWeight: '600',
    color: ONBOARDING_COLORS.mint,
  },
  lbRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 6,
    paddingHorizontal: 9,
    borderRadius: 10,
  },
  lbRowYou: {
    backgroundColor: ONBOARDING_COLORS.surfaceRaised,
    borderWidth: 1,
    borderColor: ONBOARDING_COLORS.purple,
  },
  lbRank: {
    width: 16,
    fontSize: 13,
    fontWeight: '700',
    color: ONBOARDING_COLORS.textFaint,
  },
  lbRankYou: {
    color: ONBOARDING_COLORS.purple,
  },
  lbAvatar: {
    width: 30,
    height: 30,
    borderRadius: 999,
    overflow: 'hidden',
    backgroundColor: ONBOARDING_COLORS.purpleDeep,
    alignItems: 'center',
    justifyContent: 'center',
  },
  lbMonogram: {
    width: 30,
    height: 30,
    borderRadius: 999,
    alignItems: 'center',
    justifyContent: 'center',
  },
  lbMonogramText: {
    fontSize: 11,
    fontWeight: '800',
  },
  lbName: {
    flex: 1,
    minWidth: 0,
    fontSize: 13,
    fontWeight: '600',
    color: ONBOARDING_COLORS.textPrimary,
  },
  lbNameYou: {
    fontWeight: '700',
  },
  lbDelta: {
    fontSize: 11,
    fontWeight: '700',
    color: ONBOARDING_COLORS.mint,
    marginRight: 4,
  },
  lbCoin: {
    width: 13,
    height: 13,
  },
  lbCoins: {
    fontSize: 13,
    fontWeight: '700',
    color: ONBOARDING_COLORS.gold,
  },
});
